import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import TableFooter from "@mui/material/TableFooter";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Typography from "@mui/material/Typography";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import CircularProgress from "@mui/material/CircularProgress";
import ImportExportIcon from "@mui/icons-material/ImportExport";
//
import { HeaderIconButton } from "@limitless/portal";
const useStyles = makeStyles({
  fetchRowsText: {
    marginRight: 8,
    marginBottom: 4
  },
  fetchRowsSelector: {
    marginRight: 4
  },
  footerRow: {
    display: "flex",
    justifyContent: "flex-end"
  },
  footerCell: {
    display: "flex",
    alignItems: "center"
  }
});
const DataTableFooter = ({
  isLoadMoreDisabled = true,
  limit,
  fetchRowOptions = [10, 50, 100, 1000],
  changeRowLimit,
  onLoadMore,
  loading = false
}) => {
  const classes = useStyles();
  const handleRowChange = event => {
    changeRowLimit(event.target.value);
  };
  const handleLoadMore = () => {
    onLoadMore(null, true);
  };
  return /*#__PURE__*/React.createElement(TableFooter, null, /*#__PURE__*/React.createElement(TableRow, {
    className: classes.footerRow
  }, /*#__PURE__*/React.createElement(TableCell, {
    className: classes.footerCell
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fetchRowsText,
    color: "textPrimary"
  }, "Fetch data limit:"), /*#__PURE__*/React.createElement(Select, {
    disableUnderline: true,
    className: classes.fetchRowsSelector,
    autoWidth: true,
    id: "fetchRowsAutoComplete",
    value: limit,
    onChange: handleRowChange,
    variant: "standard"
  }, fetchRowOptions.length > 0 && fetchRowOptions.map(num => /*#__PURE__*/React.createElement(MenuItem, {
    key: num,
    value: num
  }, num))), loading ? /*#__PURE__*/React.createElement(CircularProgress, {
    size: 24
  }) : /*#__PURE__*/React.createElement(HeaderIconButton, {
    disabled: isLoadMoreDisabled,
    onButtonClick: handleLoadMore,
    tooltip: "Fetch more data",
    buttonId: `fetchMoreData${Math.floor(Math.random() * 100)}`,
    icon: /*#__PURE__*/React.createElement(ImportExportIcon, null)
  }))));
};
export default DataTableFooter;
DataTableFooter.propTypes = {
  loading: PropTypes.bool,
  isLoadMoreDisabled: PropTypes.bool,
  fetchRowOptions: PropTypes.array,
  limit: PropTypes.number,
  changeRowLimit: PropTypes.func,
  onLoadMore: PropTypes.func
};